import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#17B26A",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Person avatar" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99998 11.5C5.35825 11.5 3.00898 12.7755 1.51331 14.755C1.1914 15.181 1.03044 15.394 1.03571 15.6819C1.03978 15.9043 1.17944 16.1849 1.35445 16.3222C1.58097 16.5 1.89487 16.5 2.52267 16.5H13.4773C14.1051 16.5 14.419 16.5 14.6455 16.3222C14.8205 16.1849 14.9602 15.9043 14.9642 15.6819C14.9695 15.394 14.8086 15.181 14.4866 14.755C12.991 12.7755 10.6417 11.5 7.99998 11.5Z",
			stroke: "current",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99998 9C10.071 9 11.75 7.32107 11.75 5.25C11.75 3.17893 10.071 1.5 7.99998 1.5C5.92891 1.5 4.24998 3.17893 4.24998 5.25C4.24998 7.32107 5.92891 9 7.99998 9Z",
			stroke: "current",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPersonAvatar;
